import { css } from "lit";
// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

dialog {
  width: 50vw;
  max-height: 90vh;
  margin: 5vh auto;
}

li[data-selected] {
  background: yellow;
}

.mdn-search {
  position: relative;

  display: flex;

  flex-direction: row-reverse;

  align-items: center;

  width: 5rem;

  padding: 0.5rem;

  --csstools-light-dark-toggle--0: var(--csstools-color-scheme--light) var(--color-grey-mid-light);

  border: 1px solid
    var(--csstools-light-dark-toggle--0, var(--color-grey-mid-dark));
  border-radius: 2rem;
}

@supports (color: light-dark(red, red)) {
.mdn-search {

  border: 1px solid
    light-dark(var(--color-grey-mid-dark), var(--color-grey-mid-light));
}
}

.mdn-search::before {
    position: absolute;
    right: 64%;
    bottom: 0.5rem;
    left: 14%;

    height: 2px;

    content: "";

    background-color: var(--color-text-blue);
  }
`, "",{"version":3,"sources":["webpack://./components/search-modal/element.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;;EAElB,aAAa;;EAEb,2BAA2B;;EAE3B,mBAAmB;;EAEnB,WAAW;;EAEX,eAAe;;EAEf,gGACqE;;EADrE;oEACqE;EACrE,mBAAmB;AAcrB;;AA7BA;AAAA;;EAaE;uEACqE;AAevE;AAAA;;AAZE;IACE,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,SAAS;;IAET,WAAW;;IAEX,WAAW;;IAEX,wCAAwC;EAC1C","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\ndialog {\n  width: 50vw;\n  max-height: 90vh;\n  margin: 5vh auto;\n}\n\nli[data-selected] {\n  background: yellow;\n}\n\n.mdn-search {\n  position: relative;\n\n  display: flex;\n\n  flex-direction: row-reverse;\n\n  align-items: center;\n\n  width: 5rem;\n\n  padding: 0.5rem;\n\n  border: 1px solid\n    light-dark(var(--color-grey-mid-dark), var(--color-grey-mid-light));\n  border-radius: 2rem;\n\n  &::before {\n    position: absolute;\n    right: 64%;\n    bottom: 0.5rem;\n    left: 14%;\n\n    height: 2px;\n\n    content: \"\";\n\n    background-color: var(--color-text-blue);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default css([___CSS_LOADER_EXPORT___.toString()]);
